import { render, staticRenderFns } from "./PlayerShare.vue?vue&type=template&id=5f88a87b&scoped=true&"
import script from "./PlayerShare.vue?vue&type=script&lang=js&"
export * from "./PlayerShare.vue?vue&type=script&lang=js&"
import style0 from "./PlayerShare.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./PlayerShare.vue?vue&type=style&index=1&id=5f88a87b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f88a87b",
  null
  
)

component.options.__file = "PlayerShare.vue"
export default component.exports